import { useTab } from '@atlaskit/tabs';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { ReactElement } from 'react';
import { media } from '@atlaskit/primitives/responsive';
import { Lozenge } from '@atlassian/learning-components';
import Tooltip from '@atlaskit/tooltip';

interface CustomTabProps {
  label: string;
  areUnseenNotificationsAvailable?: boolean;
}

export const CustomTab = ({ label, areUnseenNotificationsAvailable }: CustomTabProps): ReactElement => {
  const tabAttributes = useTab();

  return (
    <div css={tabStyles} {...tabAttributes}>
      {label}
      {areUnseenNotificationsAvailable && (
        <Tooltip content="We've updated some content you've completed. See what's changed and refresh your knowledge.">
          <span css={css({ marginLeft: token('space.050'), display: 'flex' })}>
            <Lozenge text="UPDATE" appearance="new"></Lozenge>
          </span>
        </Tooltip>
      )}
    </div>
  );
};

const tabStyles = css({
  fontSize: '20px',
  color: token('color.text.subtle'),
  fontFamily: 'Charlie Display, sans-serif',
  fontWeight: 600,
  lineHeight: '28px',
  textAlign: 'center',
  padding: `${token('space.100')} ${token('space.150')}  ${token('space.150')} !important`,
  display: 'flex',
  alignItems: 'center',

  '&:first-child': {
    paddingLeft: `${token('space.100')} !important`,
  },

  '&:hover[aria-selected="false"]': {
    color: '#000 !important',
  },

  '&:focus-visible': {
    borderRadius: '4px',
    outline: `2px solid ${token('color.border.focused')}`,
  },

  '&:focus-visible[aria-selected]:first-child': {
    paddingLeft: '0 !important',
  },

  [media.below.sm]: {
    fontSize: '16px',
    lineHeight: '24px',
  },

  '@media (max-width: 1279px)': {
    padding: `0 ${token('space.100')} 10px ${token('space.100')} !important`,
  },
});
